import { defineStore } from 'pinia';
import rows from '@/data/gst_rates_in.json';

export const useGstRatesStore = defineStore('gstRates', {
  state: () => ({
    rows,
    loaded: true,
  }),
  getters: {
    states: (s) => Array.from(new Set(s.rows.map(r => r.state))).sort(),
    allCategories: (s) => Array.from(new Set(s.rows.map(r => r.category))).sort(),
    categoriesByState: (s) => (state) =>
      Array.from(new Set(s.rows.filter(r => r.state === state).map(r => r.category))).sort(),
    rateFor: (s) => (state, category) => {
      const row = s.rows.find(r => r.state === state && r.category === category);
      return row ? row.rate : null;
    },
  },
});
